import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ACTIONS from 'redux-lib/actions/actions';
import { PIPEDRIVE_API } from 'api/pipedrive';
import { getDealMapping } from 'utils/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    fontFamily: 'Roboto, sans-serif'
  },
  margin: {
    margin: theme.spacing(1),
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },
  textField: {
    width: '40ch'
  },
}));

function SearchDeal(props) {
  const classes = useStyles(); 
  const dispatch = useDispatch();
  const history = useHistory();
  const states = useSelector(state => {
    return state.globalStates
  })
  const [dealNotFound, setDealNotFound] = useState("")
  // const [dealId, setDealId] = useState(null);
  const dealId = states ? states.deal_id ? states.deal_id : null : null;

  const handleChange = (event) => {
    dispatch({
      type: ACTIONS.UPDATE_DEAL_ID,
      payload: event.target.value
    })
    // setDealId(event.target.value)
  };

  const handleGetData = () => {

    // dispatch({
    //   type: ACTIONS.UPDATE_QUOTES,
    //   payload: []
    // })

    dispatch({
      type: ACTIONS.RESET_STATES
    })

    

    history.push(`/deal?id=${ dealId }`)
    setDealNotFound(false);
    dispatch({
      type: ACTIONS.UPDATE_IS_LOADING,
      payload: true
    })
    PIPEDRIVE_API.getDealData(dealId).then((data) => {
      const dealDataUpdated = getDealMapping(data);
      if(!dealDataUpdated) {
        setDealNotFound(true);
      } else {
        // const statesToClear = [
        //   'quotes',
        //   'selected_quotes',
        // ];
        // clearStates(statesToClear, []);
        updateStates(dealDataUpdated);
      }
      dispatch({
        type: ACTIONS.UPDATE_IS_LOADING,
        payload: false
      })
    })
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    handleGetData();
  }

  const clearStates = (statesToClear, defaultValue) => {
    // statesToClear.forEach((state) => {
    //   dispatch({
    //     type: `UPDATE_${ state.toUpperCase() }`,
    //     payload: defaultValue
    //   })
    // })
    dispatch({
      type: `RESET_STATES`
    })
  }

  const updateStates = (dealObj) => {
    for( const item in dealObj ) {
      dispatch({
        type: `UPDATE_${ item.toUpperCase() }`,
        payload: dealObj[item]
      })
    }
  }

  return(
    <div className={ classes.root }>
      <form onSubmit={ handleSubmit }>
      <InputLabel htmlFor="search-deal"></InputLabel>
      <Input
        className={ classes.textField }
        id="search-deal"
        type={`text`}
        value={dealId}
        name={`deal_id`}
        onChange={handleChange}
        placeholder="Search Deal ID"
        color="primary"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="search"
              onClick={handleGetData}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
      />
      {
        dealNotFound ? <small style={{ display: 'block' }}>No Deal Found</small> : ''
      }
      
      </form>
    </div>
  )
}

export default SearchDeal;